// removed by extract-text-webpack-plugin
module.exports = {"photos_grid":"photos_grid__2poj_","grid_item":"grid_item__3-5H5","gallery_info":"gallery_info__3jnVc"};


//////////////////
// WEBPACK FOOTER
// ./components/gallery_block/style.css
// module id = Ci/U
// module chunks = 0